'use client';

import { CategoryForm } from '@/components/admin/people/CategoryForm';

export default function AdminPersonCategoryNewPage() {
  return <CategoryForm />;
}
